export default __webpack_public_path__ + "static/media/downlight100.956d345a.svg";